import React, { useEffect, useMemo, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetAllModelDropdownListQuery } from '../../api';

const ModelDropdown = ({ value, onChange, brand, productGroup, modelName, className = '', disabled = false, placeholder = 'Model seçiniz veya arayınız' }) => {
    const [searchText, setSearchText] = useState('');

    const { data: modelData = [], isLoading } = useGetAllModelDropdownListQuery({
        brandName: brand ?? '',
        productGroup: productGroup ?? '',
        modelName: modelName ?? ''
    });

    const modelOptions = useMemo(() => {
        return modelData?.map((model) => ({
            id: model.id,
            name: model.model,
            displayValue: model.model
        }));
    }, [modelData]);

    const selectedOption = useMemo(() => {
        if (!value) return null;

        return modelOptions.find((opt) => opt.id === value.id) || modelOptions.find((opt) => opt.name === value.name) || value;
    }, [value, modelOptions]);

    return (
        <Dropdown
            value={selectedOption}
            options={modelOptions}
            onChange={(e) => onChange(e.value)}
            onFilter={(e) => setSearchText(e.filter)}
            optionLabel="displayValue"
            filter
            showClear
            filterBy="id,name"
            className={className}
            placeholder={placeholder}
            loading={isLoading}
            disabled={disabled}
            virtualScrollerOptions={{ itemSize: 38 }}
            itemTemplate={(option) => (
                <div>
                    <span style={{ fontWeight: 'bold' }}>{option.id}</span> - {option.name}
                </div>
            )}
        />
    );
};

export default ModelDropdown;
